import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { apiurl } from '../../utils/constants';
import { format } from 'date-fns';
import { PDFDocument } from 'pdf-lib';
import ModUserDialog from '../cc/editCC';
import CreateBillComm from './creaBillComm';
import CreateBillPrivateComm from './creaBillPrivateComm';
import RejeInvo from './rejeInvo';
import CreaBillLink from './creaBillLink';
import ExpoBillSap from './expoBillSap';
import { log } from '../../utils/functions';
import { fCurr, getInvoiceStatusInfo, sendMail, getDaysUntilDue } from '../../utils/functions';


function ListInvoDeta({ onMenuItemClick, iden, docu, filtr }) {

	const [invoices, setInvoices] = useState([]);
	const [orders, setOrders] = useState([]);
	const [billPost, setBillPost] = useState([]);
	const [isModDialog, setIsModDialog] = useState(false);
	const [isModDialogRej, setIsModDialogRej] = useState(false);
	const [isExpoDialog, setIsExpoDialog] = useState(false);
	const [userReqAppr, setUserReqAppr] = useState({}); // aprobador adicional
	const [approverChangedByDialog, setApproverChangedByDialog] = useState(false);
	const [isSetIsBillComm, setIsBillComm] = useState(false);
	const [isGeneratingDocument, setIsGeneratingDocument] = useState(false);
	const [loading, setLoading] = useState(true)
	const [billLink, setBillLink] = useState(false);
	const [files, setFiles] = useState([]);
	const { iden: iuser, role, mail, sapDB, budg, sap_user, comp } = useSelector((state) => state.user);
	const currentUrl = window.location.origin;

	console.log('ListInvoDeta render', { onMenuItemClick, iden, docu });

	const loadOrders = useCallback(async () => {
		try {

			const response = await fetch(apiurl + `getpurchaseOrdersByInvoice`, {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB, user: mail, DocNum: docu
				})
			});
			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}
			const data = await response.json();
			// Eliminar órdenes duplicadas por DocNumOC
			const uniqueOrders = Array.isArray(data)
				? [...new Map(data.map(o => [o.DocNumOC, o])).values()]
				: data;
			setOrders(uniqueOrders);
		} catch (error) {
			console.error('Error fetching orders:', error);
		} finally {
			setLoading(false);
		}
	}, [docu, mail, sapDB]);

	const loadInvoices = useCallback(async () => {
		try {

			console.log({
					sapDB, user: mail, DocNum: docu, iden_form: iden
				})

			const response = await fetch(apiurl + `invoices`, {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB, user: mail, DocNum: docu, iden_form: iden
				})
			});

			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}
			const data = await response.json();
			setInvoices(Array.isArray(data) ? data[0] : data);
			// Seteando por defecto el aprobador adicional
			if (data[0]?.name_approver) {
				setUserReqAppr({
					iden_user: data[0].approver,
					name_user: data[0].name_approver,
					mail_user: data[0].mail_approver,
					confirm_approver: data[0].confirm_approver
				});
			} else if (data[0]?.cc_mail_user) {
				setUserReqAppr({
					iden_user: data[0].bill_approver,
					name_user: data[0].cc_name_user,
					mail_user: data[0].cc_mail_user,
					confirm_approver: data[0].confirm
				});
			}

			loadOrders();

		} catch (error) {
			console.error('Error fetching invoices:', error);
		}
	}, [docu, iden, loadOrders, mail, sapDB]);

	const resendNotification = async () => {

		if (!userReqAppr?.mail_user) {
			alert('No hay aprobador, no se puede reenviar una notificación.');
			return;
		}

		if (window.confirm(`Se reenviará una notificación por email a ${userReqAppr?.mail_user} para aprobar esta factura.\n¿Está seguro?`)) {
			notification();
		}

	}

	const notification = async () => {
		try {

			const tablaHTML = invoices.items && invoices.items.length > 0 ? `
				<table style="border-collapse: collapse; width: 50%;">
					<tbody>
					${invoices.items.map(item => `
						<tr>
							<td style="border: 1px solid #dddddd; text-align: left; padding: 8px;">${item.Dscription}</td>
							<td style="border: 1px solid #dddddd; text-align: left; padding: 8px;">${item.Quantity}</td>
						</tr>
					`).join('')}
					</tbody>
				</table>
			` : '';

			const body = `
					Se ha generado la factura N°${invoices.FolioNum} con los siguientes elementos:
					<br><br>
					${tablaHTML ? `${tablaHTML}<br>` : ''}
					Puede ver la factura completa <a href=${currentUrl}?db=${sapDB}&bill=${docu}>aquí</a>.
					<br><br>
					Puede aprobar esta factura <a href=${currentUrl}?db=${sapDB}&approve=${userReqAppr?.confirm_approver}&bill=${docu}>aquí</a>.
					<br><br>
				`;

			if (userReqAppr?.mail_user) await sendMail(`${userReqAppr?.mail_user}, sebastian.sagardia@bailacthor.com, benja@bailacgts.com`, `Se ha ingresado la factura N°${invoices.FolioNum} que requiere su aprobación.`, body);


		} catch (error) {
			console.error('Error reenviando notificación:', error);
			alert('Error reenviando notificación: ' + error.message);
		}
	}

	useEffect(() => {

		if (userReqAppr?.iden_user && approverChangedByDialog) {
			const updateApprover = async () => {
				try {
					const response = await fetch(apiurl + `queryAux`, {
						method: 'POST',
						credentials: 'include',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({
							sapDB,
							user: mail,
							query: `UPDATE bil__form SET approver = ${userReqAppr.iden_user} WHERE docu = ${docu}`
						})
					});

					if (!response.ok) {
						throw new Error(`Error: ${response.status} ${response.statusText}`);
					} else {
						resendNotification();
					}

				} catch (error) {
					console.error('Error al actualizar el aprobador:', error);
				} finally {
					setApproverChangedByDialog(false);
				}
			};

			updateApprover();
		}
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userReqAppr]);

	const approbBill = async () => {
		const folioNum = Number(invoices?.FolioNum);
		if (invoices?.FolioNum == null || folioNum < 1) {
			alert('Error: FolioNum inválido para aprobar la factura.');
			return;
		}
		
		if (window.confirm(`¿Está seguro de aprobar la factura ${folioNum}?`)) {
			try {
				const response = await fetch(apiurl + `queryAux`, {
					method: 'POST',
					credentials: 'include',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						sapDB,
						user: mail,
						query: `UPDATE bil__form SET approved=now(), approver=${iuser} WHERE docu = ${docu}`
					})
				});
				if (!response.ok) {
					throw new Error(`Error: ${response.status} ${response.statusText}`);
				}

				log('mod', 'bill', docu, mail, iuser, `approb bill ${docu}`);

				let body = `
					${userReqAppr.name_user} ha aprobado la factura N°${invoices.FolioNum}.
					<br>
					Correspondiente a la empresa: 
					<br>${invoices?.CardCode} - ${invoices?.CardName}.
					<br><br>
					Puede ver la factura aquí: <a href=${currentUrl}?db=${sapDB}&bill=${docu}>aquí</a>.`;

				await sendMail("contabilidad@bailacthor.com", `La factura N°${invoices.FolioNum} de ${invoices?.CardName} (${invoices?.CardCode}) ha sido aprobada.`, body);
				alert(`Factura N°${invoices.FolioNum} aprobada correctamente.`);

				onMenuItemClick('listInvoice', null, null, filtr);
			} catch (error) {
				console.error('Error aprobando factura:', error);
				alert('Error aprobando factura: ' + error.message);
			}
		}
	};

	const deleteBill = async () => {
		if (window.confirm(`Se eliminará esta factura importada sin haber sido exportada a SAP.\n\nEsta acción no puede deshacerse.\n\n¿Está seguro?`)) {
			try {
				const response = await fetch(apiurl + `invo/deleteINVO`, {
					method: 'POST',
					credentials: 'include',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						sapDB,
						user: mail,
						iden_form: iden
					})
				});
				if (!response.ok) {
					throw new Error(`Error: ${response.status} ${response.statusText}`);
				}
				log('del', 'bill', docu, mail, iuser, `delete bill ${docu}`);
				onMenuItemClick('listInvoice', null, null);
			} catch (error) {
				console.error('Error eliminando factura:', error);
				alert('Error al eliminar la factura: ' + error.message);
			}
		}
	};

	const reEvaluate = async () => {
		if (window.confirm(`Esta factura fue rechazada por un motivo.\n\n¿Estos motivos fueron solucionados?`)) {
			try {
				const response = await fetch(apiurl + `queryAux`, {
					method: 'POST',
					credentials: 'include',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						sapDB,
						user: mail,
						query: `UPDATE bil__form SET rejected=null, rejector=null, reason=null WHERE docu = ${docu}`
					})
				});
				if (!response.ok) {
					throw new Error(`Error: ${response.status} ${response.statusText}`);
				}

				log('mod', 'bill', docu, mail, iuser, `re-evaluate bill ${docu}`);

				notification();
				onMenuItemClick('listInvoice', null, null, filtr);
			} catch (error) {
				console.error('Error solicitando reevaluación:', error);
				alert('Error solicitando reevaluación: ' + error.message);
			}
		}
	}

	const loadFile = useCallback(async () => {
		try {
			const response = await fetch(apiurl + `queryAux`, {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB,
					user: mail,
					query: `SELECT link.iden, publ, auth, file, name FROM bil__link link LEFT JOIN sys__user user ON user.iden=link.auth WHERE iden_form = ${iden}`
				})
			});
			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}
			const data = await response.json();
			setFiles(data);
		} catch (error) {
			console.error('Error loading file:', error);
		}
	}, [iden, mail, sapDB])



	const handleLinkDel = (idenFile, url) => {
		try {
			const confirmed = window.confirm(`¿Está seguro de eliminar este archivo?\n${url}`);
			if (!confirmed) return;

			fetch(apiurl + `deleteFileToBill`, {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB,
					user: mail,
					entry: invoices.entry,
					path: url,
					idenFile: idenFile
				})
			})
				.then(response => {
					if (!response.ok) {
						throw new Error(`Error: ${response.status} ${response.statusText}`);
					}
					loadFile();
				})
				.catch(error => {
					console.error('Error deleting link:', error);
					alert('Error al eliminar el archivo: ' + error.message);
				});
		} catch (error) {
			console.error('Error deleting link:', error);
		}

	};

	const loadBillPost = useCallback(async () => {
		try {
			const response = await fetch(apiurl + `queryAux`, {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB,
					user: mail,
					query: `SELECT bil__post.iden,note,publ,mess,user.name auth_name, auth 
							FROM bil__post INNER JOIN sys__user user ON bil__post.auth=user.iden 
							WHERE iden_form = ${iden} AND note=0 ORDER BY bil__post.iden DESC`
				})
			});
			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}
			const data = await response.json();
			setBillPost(Array.isArray(data) ? data : []);
		} catch (error) {
			console.error('Error fetching bill post:', error);
			setBillPost([]);
		}
	}, [iden, mail, sapDB])

	const handleEditComment = (comment) => {

		const updatedComments = billPost.map((item) => {
			if (item.iden === comment.iden && (item.auth === iuser || role === '3')) {
				return {
					...item,
					isEditing: true,
				};
			}
			return item;
		});
		setBillPost(updatedComments);
	};

	const deleteReg = async (ritem_iden, table) => {
		try {
			const response = await fetch(apiurl + 'tableDEL', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					table: table,
					where: `iden=${ritem_iden}`,
				}),
			});

			if (response.ok) {
				loadBillPost();
			} else console.error('Error al eliminar el artículo en el servidor');
		} catch (error) {
			console.error('Error en la solicitud:', error);
		}
	};

	const updateReg = async (ritem_iden, table, fields) => {
		try {

			const response = await fetch(apiurl + 'tablePUT', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					table: table,
					fields: fields,
					iden: `iden=${ritem_iden}`,
				}),
			});

			if (response.ok) {
			} else console.error('Error al actualizar el artículo en el servidor');
		} catch (error) {
			console.error('Error en la solicitud:', error);
		}
	}

	const handleCommChange = (comment, newComm) => {
		const updatedBill = billPost.map((comm) => {
			if (comm.iden === comment.iden) {
				if (!newComm) {
					if (window.confirm('¿Eliminar este comentario?')) {
						log('mod', 'bill', docu, mail, iuser, `del mess ${docu}`);
						deleteReg(comment.iden, 'bil__post');
					}
				} else {
					log('mod', 'bill', docu, mail, iuser, `mod mess ${docu}`);
					updateReg(comm.iden, 'bil__post', `publ=now(), note=0 , mess='${newComm}' `);
					return { ...comm, mess: newComm, publ: new Date() };
				}
			}
			return comm;
		});
		setBillPost(updatedBill);
	};


	const handleCommBlur = (comment) => {
		const updatedBill = billPost.map((comm) => {
			if (comm.iden === comment.iden) {
				return { ...comm, isEditing: false };
			}
			return comm;
		});
		setBillPost(updatedBill);
	};

	useEffect(() => {
		loadInvoices();
		loadBillPost();
	}, [loadBillPost, loadInvoices]);

	useEffect(() => {
		loadFile();
	}, [invoices, loadFile])

	const getNameDocument =useCallback((FolioPref) => {
		if (isNaN(Number(FolioPref))) return "Error número " + FolioPref;

		switch (Number(FolioPref)) {
			case 33:
				return "Factura"
			case 34:
				return "Factura exenta"
			case 46:
				return "Factura de terceros"
			case 61:
				return "Nota de crédito"
			case 914:
				return "Declaración de ingreso"
			default:
				return "Error"

		}
	}, [])

	const invoicePdfUrl = invoices?.CardCode && invoices?.FolioPref && invoices?.FolioNum
		? `https://bailacorm.s3.sa-east-1.amazonaws.com/invoices/${String(invoices.CardCode).replace(/^PN/i, '').trim()}_${String(invoices.FolioPref).trim()}_${String(invoices.FolioNum).trim()}.pdf`
		: '';

	const linkedOrderDocNums = useMemo(
		() => (Array.isArray(orders) && orders.length > 0
			? orders.map((order) => order?.DocNumOC).filter(Boolean)
			: []),
		[orders]
	);

	const openOrderPdf = useCallback(async () => {
		if (isGeneratingDocument) return;

		if (!invoicePdfUrl && linkedOrderDocNums.length === 0) {
			alert('No hay documentos para abrir.');
			return;
		}

		try {
			setIsGeneratingDocument(true);
			const mergedPdf = await PDFDocument.create();
			let hasPages = false;

			// Agregar factura primero
			if (invoicePdfUrl) {
				try {
					const invoiceResponse = await fetch(invoicePdfUrl);
					if (!invoiceResponse.ok) throw new Error(`Error al descargar factura: ${invoiceResponse.status}`);
					const invoiceBytes = await invoiceResponse.arrayBuffer();
					const invoicePdf = await PDFDocument.load(invoiceBytes);
					const invoicePages = await mergedPdf.copyPages(invoicePdf, invoicePdf.getPageIndices());
					invoicePages.forEach((page) => mergedPdf.addPage(page));
					hasPages = hasPages || invoicePages.length > 0;
				} catch (error) {
					console.error('No se pudo agregar el PDF de factura:', error);
				}
			}

			// Agregar OCs desde el endpoint /orderPDF
			for (const orderDocNum of linkedOrderDocNums) {
				try {
					const orderResponse = await fetch(apiurl + 'orderPDF', {
						method: 'POST',
						credentials: 'include',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({
							sapDB,
							DocNum: orderDocNum
						})
					});

					if (!orderResponse.ok) {
						console.error(`Error al descargar OC ${orderDocNum}: ${orderResponse.status}`);
						continue;
					}

					const orderBytes = await orderResponse.arrayBuffer();
					const orderPdf = await PDFDocument.load(orderBytes);
					const orderPages = await mergedPdf.copyPages(orderPdf, orderPdf.getPageIndices());
					orderPages.forEach((page) => mergedPdf.addPage(page));
					hasPages = hasPages || orderPages.length > 0;
				} catch (error) {
					console.error(`Error procesando OC ${orderDocNum}:`, error);
				}
			}

			if (!hasPages) {
				alert('No se pudo generar ningún PDF para mostrar.');
				return;
			}

			const mergedBytes = await mergedPdf.save();
			const blobUrl = URL.createObjectURL(new Blob([mergedBytes], { type: 'application/pdf' }));
			window.open(blobUrl, '_blank');
		} catch (error) {
			console.error('Error uniendo PDFs:', error);
			alert('No se pudo generar el documento combinado.');
		} finally {
			setIsGeneratingDocument(false);
		}
	}, [invoicePdfUrl, isGeneratingDocument, linkedOrderDocNums, sapDB]);

	// Calcular clase de vencimiento
	const days = getDaysUntilDue(invoices.DocDueDate);
	const vencimientoClass = days < 1 ? 'red' : (days <= 7 && days >= 1 ? 'ora' : '');
	return (
		<>
			<form onSubmit={(e) => e.preventDefault()}>
				<style jsx="true">{`.itemTable .ellipsis{max-width: 500px;}`}</style>
				<main>
					<h1 data-icon='' className={`${getInvoiceStatusInfo(invoices?.DocumentStatus).color}`}>
						<span>{getNameDocument(invoices.FolioPref)} {invoices.FolioNum ? `${invoices.FolioPref}-` : ''}{invoices?.FolioNum}</span>
						<mark>{getInvoiceStatusInfo(invoices?.DocumentStatus).title}</mark>
					</h1>
					<nav>
						<section>
							<h2>
								<div>Contabilización</div>
								<div>
									{invoices?.DocDate
										? invoices.DocDate.slice(0, 10).split('-').reverse().join('/')
										: '-'}
								</div>
							</h2>
							<fieldset>
								<legend>Contador</legend>
								<a href={currentUrl} onClick={(e) => e.preventDefault()}>{invoices?.U_NAME}</a>
								{ (!invoices?.docu && sap_user) ? <input type="button" value="Exportar a SAP" onClick={() => setIsExpoDialog(true)} /> : <></> }
								{ (!invoices?.docu && sap_user) ? <input type="button" value="Eliminar factura" onClick={deleteBill} /> : <></> }
							</fieldset>
							<fieldset>
								<legend>Centro de costos</legend>
								<a href={currentUrl} onClick={(e) => e.preventDefault()}>{invoices?.cent}. {invoices?.cc_name}</a>
							</fieldset>
							<fieldset>
								<legend>Proveedor</legend>
								<a href={currentUrl} onClick={(e) => e.preventDefault()}>{invoices?.CardCode} {invoices?.CardName}</a>
							</fieldset>
						</section>
						<section>
							<h2>
								<div>{invoices?.rejected ? 'Rechazo' : 'Aprobación'}</div>
								<div>
									{invoices?.rejected
										? invoices.rejected.slice(0, 10).split('-').reverse().join('/')
										: (invoices?.approved
											? invoices.approved.slice(0, 10).split('-').reverse().join('/')
											: '--/--/----')}
								</div>
							</h2>

							{
								invoices?.rejected ?
									(<>
										<fieldset>
											<legend>Evaluador</legend>
											<div>{invoices.name_rejector}</div>
										</fieldset>
										<fieldset>
											<legend>Motivo</legend>
											<blockquote>{invoices.reason}</blockquote>
											{
												budg ?
													(
														<>
															<input type="button" value="Solicitar Reevaluación" onClick={reEvaluate} />
														</>
													) : <></>
											}
										</fieldset>
									</>)
									:
									(<fieldset>
										<legend>Aprobador</legend>
										{
											invoices?.approved
												? (
													<table>
														<tbody>
															<tr>
																<td ><a href={currentUrl} onClick={(e) => e.preventDefault()}>{invoices.name_approver}</a></td>
																<td><figure className="blu"></figure></td>
															</tr>
														</tbody>
													</table>
												)
												: <a href={currentUrl} onClick={(e) => e.preventDefault()}>{userReqAppr?.name_user ? userReqAppr.name_user : invoices?.cc_name_user}</a>
										}
										{
											budg && !invoices?.approved ?
												(
													<>
														{invoices?.DocumentStatus !== 'Draft' && (
															<input type="button" value="Reenviar notificación" onClick={resendNotification} disabled={invoices?.approved || invoices?.DocumentStatus === 'C' ? true : false} />
														)}
														<input type="button" value="Cambiar aprobador" onClick={() => { setIsModDialog(true); setApproverChangedByDialog(true); }} disabled={invoices?.approved || invoices?.DocumentStatus === 'C' ? true : false} />
													</>
												) : <></>
										}
										{
											iuser === userReqAppr?.iden_user && invoices?.requested ? (
												<>
													<input type="button" value="Aprobar factura" onClick={() => approbBill()} disabled={invoices?.approved || invoices?.DocumentStatus === 'C' ? true : false} />
													<input type="button" value="Rechazar factura" onClick={() => { setIsModDialogRej(true) }} disabled={invoices?.approved || invoices?.DocumentStatus === 'C' ? true : false} />
												</>
											) : <></>
										}
									</fieldset>)
							}
						</section>
						<section>
							<h2><div>Compra</div><div></div></h2>
							<fieldset>
								{
									orders && orders.length > 0 ? (
										<>
											<legend>Orden de compra</legend>
											<table>
												<tbody>
													{orders.map((order, idx) => (
														<tr key={idx}>
															<td> <figure className={order.DocStatusOC === 'O' ? "red" : "gre"}></figure> OC {order.DocNumOC} {order.sent_supp ? (<figure className={order.sent_error ? 'ora' : 'blu'} title={order.sent_error ?? `Enviado al proveedor el ${order.sent_supp}`}></figure>) : <></>}</td>
															<td> {order.DocDate} </td>
															<td><a href={currentUrl} onClick={(e) => e.preventDefault()}><figure onClick={() => onMenuItemClick('listOcDeta', order.DocNumOC, { 'FolioNum': invoices?.FolioNum, docu, iden: invoices?.iden_form }, filtr, 'order')}></figure></a></td>
														</tr>
													))}
												</tbody>
											</table>
										</>
									) : (
										<p>{loading ? "Buscando orden de compra..." : "No hay órdenes de compra asociadas a esta factura."}</p>
									)
								}
							</fieldset>
							{
								invoices.DocTotal === invoices.PaidToDate ?
								<></> :
								(<fieldset className={vencimientoClass}>
									<legend>Vencimiento</legend>
									<time>
										{invoices?.DocDueDate
											? invoices.DocDueDate.slice(0, 10).split('-').reverse().join('/')
											: '--/--/----'}
									</time>
									<span>
										({getDaysUntilDue(invoices.DocDueDate) < 1 ? `Vencido` : `Quedan ${getDaysUntilDue(invoices.DocDueDate)} días`})
									</span>
								</fieldset>
								)
							}
						</section>
						<article className='scrollx'>
							{
								invoices?.items && invoices.items.length > 0 ? (
									<table className='itemTable'>
										<thead>
											<tr>
												<td>{invoices?.items?.some(item => !!item.ItemCode) ? 'Código' : 'Cuenta'}</td>
												<td className="ellipsis">Descripción</td>
												<td>Precio</td>
												<td>Cantidad</td>
												<td>Costo</td>
											</tr>
										</thead>
										<tbody>
											{
												invoices.items.map((item, idx) => (
													<tr key={item.id__ || idx}>
														<td>{item.ItemCode ?? item.AccountCode}</td>
														<td className='ellipsis'>{item.ItemCode ? item.Dscription : item.AccountName}</td>
														<td>{fCurr(item.Price)} CLP</td>
														<td>{fCurr(item.Quantity)}</td>
														<td>{fCurr(item.Price * item.Quantity)} CLP </td>
													</tr>
												))
											}
										</tbody>
									</table>
								) : (
									<p>No hay items en esta factura.</p>
								)
							}
						</article>
						<h2>
							{
								invoices?.DocTotal ? (
									<div>NETO: {fCurr(invoices.DocTotal - (invoices.VatSum ?? 0))} CLP</div>
								) : (
									<div></div>
								)}
							{
								invoices?.VatSum ? (
									<div>IVA: {fCurr(invoices.VatSum)} CLP</div>
								) : (
									<div>IVA: 0 CLP</div>
								)
							}
							{
								invoices?.DocTotal ? (
									<div>Bruto: {fCurr(invoices.DocTotal)} CLP</div>
								) : (
									<div></div>
								)
							}
						</h2>

						<Comentarios
							publicComment={invoices.Comments}
							idenForm={iden}
							docu={docu}
							bill={invoices}
						/>
										{/*
										{invoices?.Comments ? invoices.Comments.split('\n').map((line, idx) => (
											<span key={idx}>{line}<br /></span>
										)) : <i>No hay comentarios en esta factura.</i>
										}
										*/}
						<section>
							<h2>Conversación interna</h2>
							<fieldset>
								{
									billPost.map((comment) => (
										<div key={comment.iden} className="comment">
											{comment.isEditing ? (
												<textarea value={comment.mess} onChange={(e) => handleCommChange(comment, e.target.value)} onBlur={() => handleCommBlur(comment)} />)
												: (
													<>
														<blockquote className={comment.auth === iuser ? 'editable' : ''} onClick={comment.auth === iuser ? () => handleEditComment(comment) : null}>{comment.mess}</blockquote>
														<footer> Por <cite>{comment.auth_name}</cite> <dt>{comment.publ ? format(new Date(comment.publ), 'dd/MM/yyyy HH:mm') : ''}</dt> </footer>
													</>)

											}
										</div>
									))
								}
								{budg ? (<input type="button" onClick={() => setIsBillComm(true)} value="Agregar mensaje" />) : null}
							</fieldset>
						</section>
						<section>
							<h2>Adjuntos</h2>
							<fieldset>
								<>
									{
										Array.isArray(files) && files.length > 0 ? (
											files.map((link) => (
												<div key={link.iden}>
													<blockquote>
														<a href={link.file} target="_blank" rel="noreferrer">{link.file.substring(link.file.lastIndexOf('/', link.file.length - 2) + 1).replace(/\/$/, '')}</a>
														<span className={budg ? 'deletable' : ''} onClick={budg ? () => handleLinkDel(link.iden, link.file) : null}></span>
													</blockquote>
													<footer>
														Por <cite>{link.name}</cite>
														<dt>{format(new Date(link.publ), 'dd/MM/yyyy HH:mm')}</dt>
													</footer>
												</div>
											))
										) : (
											<p>No hay archivos adjuntos.</p>
										)
									}
									<input type="button" value="Agregar adjunto" onClick={() => setBillLink(true)} />
								</>
							</fieldset>
						</section>
					</nav>
				</main>
				<aside>
					<article>
						<h2>Acciones</h2>
						<fieldset>
							<input
								type="button"
								value="Ver documento"
								onClick={openOrderPdf}
								disabled={isGeneratingDocument || (!invoicePdfUrl && (linkedOrderDocNums.length === 0 || !comp))}
							/>
							<input type="button" onClick={() => onMenuItemClick('listInvoice', null, null, filtr)} value="Volver a facturas" />
						</fieldset>
					</article>
				</aside>
			</form>
			{isModDialog && <ModUserDialog solp={null} onUpdateCCList={null} onEditCC={null} onClose={() => setIsModDialog(false)} onSetOneUser={setUserReqAppr} />}
			{isModDialogRej && <RejeInvo bill={docu} onClose={() => setIsModDialogRej(false)} onRefresh={() => onMenuItemClick('listInvoice', null, null, filtr)} />}
			{isSetIsBillComm && <CreateBillComm bill={invoices} onLoadBillComm={loadBillPost} userNotify={{ mailAppr: userReqAppr.mail_user, mailCoun: mail }} onClose={() => setIsBillComm(false)} />}
			{billLink && <CreaBillLink onClose={() => setBillLink(false)} formId={iden} onLoad={loadFile} />}
			{isExpoDialog && (
				<ExpoBillSap
					idForm={iden}
					onClose={(refresh) => {
						setIsExpoDialog(false);
						if (refresh === true) {
							loadInvoices();
							loadBillPost();
							loadFile();
						}
					}}
				/>
			)}
		</>
	)
}


function Comentarios({
	publicComment,
	idenForm,
	docu,
	bill,
}) {
	const [isSetIsBillPrivateComm, setIsBillPrivateComm] = useState(false);
	const [privateComment, setPrivateComment] = useState(null);
	const [isEditingPrivateComment, setIsEditingPrivateComment] = useState(false);
	const [privateCommentDraft, setPrivateCommentDraft] = useState('');
	const { iden: iuser, role, mail, sapDB, budg } = useSelector((state) => state.user);

	const loadPrivateComment = useCallback(async () => {
		try {
			const response = await fetch(apiurl + 'queryAux', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB,
					user: mail,
					query: `SELECT bil__post.iden, bil__post.mess, bil__post.publ, bil__post.auth, user.name auth_name
							FROM bil__post
							INNER JOIN sys__user user ON bil__post.auth=user.iden
							WHERE iden_form = ${idenForm} AND note=1 ORDER BY bil__post.iden DESC LIMIT 1`
				})
			});

			if (!response.ok) {
				throw new Error(`Error: ${response.status} ${response.statusText}`);
			}

			const data = await response.json();
			setPrivateComment(data?.[0] || null);
		} catch (error) {
			console.error('Error fetching private bill comment:', error);
			setPrivateComment(null);
		}
	}, [idenForm, mail, sapDB]);

	const deletePrivateReg = async (commentId) => {
		try {
			const response = await fetch(apiurl + 'tableDEL', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					table: 'bil__post',
					where: `iden=${commentId}`,
				}),
			});

			if (!response.ok) {
				console.error('Error al eliminar el comentario privado en el servidor');
			}
		} catch (error) {
			console.error('Error en la solicitud:', error);
		}
	};

	const updatePrivateReg = async (commentId, newComment) => {
		try {
			const response = await fetch(apiurl + 'tablePUT', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					table: 'bil__post',
					fields: `publ=now(), note=1 , mess='${newComment}' `,
					iden: `iden=${commentId}`,
				}),
			});

			if (!response.ok) {
				console.error('Error al actualizar el comentario privado en el servidor');
			}
		} catch (error) {
			console.error('Error en la solicitud:', error);
		}
	};

	const handlePrivateCommentSave = async (newComment) => {
		if (!privateComment?.iden) return;

		if (!newComment.trim()) {
			if (window.confirm('¿Eliminar este comentario privado?')) {
				//log('mod', 'bill', docu, mail, iuser, `del private note ${docu}`);
				await deletePrivateReg(privateComment.iden);
				setPrivateComment(null);
			}
			return;
		}

		//log('mod', 'bill', docu, mail, iuser, `mod private note ${docu}`);
		await updatePrivateReg(privateComment.iden, newComment);
		setPrivateComment((prev) => ({ ...prev, mess: newComment, publ: new Date() }));
	};

	useEffect(() => {
		loadPrivateComment();
	}, [loadPrivateComment]);

	useEffect(() => {
		setIsEditingPrivateComment(false);
		setPrivateCommentDraft(privateComment?.mess || '');
	}, [privateComment?.iden, privateComment?.mess]);

	const canEditPrivateComment = Boolean(privateComment && (privateComment.auth === iuser || role === '3' || budg));

	return <>
		<section>
			<h2>Comentarios</h2>
			<fieldset>
				<legend>Comentario público</legend>
				<blockquote><span>{publicComment || ''}</span></blockquote>
			</fieldset>
			<fieldset>
				<legend>Comentario privado</legend>
				{
					privateComment ? (
						isEditingPrivateComment ? (
							<textarea
								value={privateCommentDraft}
								onChange={(e) => setPrivateCommentDraft(e.target.value)}
								onBlur={async () => {
									await handlePrivateCommentSave(privateCommentDraft);
									setIsEditingPrivateComment(false);
								}}
							/>
						) : (
							<>
								<blockquote className={canEditPrivateComment ? 'editable' : ''} onClick={canEditPrivateComment ? () => setIsEditingPrivateComment(true) : undefined}>{privateComment.mess}</blockquote>
							</>
						)
					) : (
						<input type="button" value="Agregar comentario privado" onClick={() => setIsBillPrivateComm(true)}></input>
					)
				}
			</fieldset>
			{isSetIsBillPrivateComm && (
				<CreateBillPrivateComm
					bill={bill}
					onClose={() => setIsBillPrivateComm(false)}
					onSaved={() => {
						loadPrivateComment();
					}}
				/>
			)}
		</section>
	</>
}

export default ListInvoDeta;